export const findUserUpdates = (currentUsers: { userId: string }[], updatedUsers: { userId: string }[]) => {
    const addedUsers = updatedUsers.filter(
        updatedUser => !currentUsers.some(currentUser => currentUser.userId === updatedUser.userId),
    );

    const removedUsers = currentUsers.filter(
        currentUser => !updatedUsers.some(updatedUser => updatedUser.userId === currentUser.userId),
    );

    return { addedUsers, removedUsers };
};
